module.exports = __webpack_public_path__ + "static/media/Pirate Girl.7fd91b18.jpg";